import { useEffect } from 'react';
import BrandBar from './components/BrandBar';
import HeroSection from './components/HeroSection';
import ApproachSection from './components/ApproachSection';
import ExpertiseSection from './components/ExpertiseSection';
import ContactFooter from './components/ContactFooter';

const structuredData = {
  '@context': 'https://schema.org',
  '@type': 'Corporation',
  name: 'EILASA, UAB',
  description:
    'Professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies.',
  url: 'https://eilasa.com/',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Partizanu g. 61-806',
    addressLocality: 'Kaunas',
    postalCode: '49282',
    addressCountry: 'LT',
  },
  telephone: '+370 66806319',
  email: 'ceo@eilasa.com',
  knowsAbout: [
    'iOS Platform Engineering',
    'System Architecture',
    'Performance Optimization',
    'Software Development',
  ],
};

export default function Home() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <main className="w-full min-h-screen bg-background-50">
      <BrandBar />
      <HeroSection />
      <ApproachSection />
      <ExpertiseSection />
      <ContactFooter />
    </main>
  );
}